import React from "react";
import logo from "../assets/youro-logo.png";

/**
 * The Youro wordmark, the same artwork the mobile app uses
 * (youro_mobile assets/images/logo-green.png: Sage on transparent).
 *
 * The public pages used to show a placeholder instead: a green "Y" square with
 * "Youro" typed beside it, which never read as the logo. The pages wrap this in
 * a link labelled "Youro home", so the image's own alt text is only a fallback.
 */
const BrandLogo = ({ className = "home-nav-logo" }) => (
  <img src={logo} alt="Youro" className={className} width={634} height={176} />
);

export default BrandLogo;
